import {
  CreateEcommercePayloadItemParams,
  createEcommercePayload,
} from '@/features/gtm/internal/helper/create-ecommerce-payload';
import { emitGTMEvent } from '@/features/gtm/shared/helper/emit-gtm-event';

export type TrackViewItemParams = CreateEcommercePayloadItemParams;

export function trackViewItem(params: TrackViewItemParams): void {
  const payload = createEcommercePayload(params);
  emitGTMEvent('VIEW_ITEM', payload);
}
